<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { UserGroup } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import EditUserGroup from './EditUserGroup.vue';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        userGroup: UserGroup;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="userGroup">
        <EditUserGroup
            v-if="hasPermission(Permission.COMPANIES_UPDATE)"
            :user-group="userGroup"
        />
        <Delete
            v-if="hasPermission(Permission.COMPANIES_DELETE)"
            :route="route('v2.user-groups.destroy', userGroup.id)"
            :query-key="[QueryKey.USER_GROUPS]"
            success-message="user-groups.deleted"
            error-message="user-groups.delete.error"
        />
    </DataTableActions>
</template>
